import { Component, OnInit } from '@angular/core';
import { withAngular } from 'slate-angular';
import { createEditor, Transforms, Editor, Element } from 'slate';
import { DemoElementImageComponent } from '../components/image/image-component';
import { ImageElement } from '../../../custom-types';
import { FormsModule } from '@angular/forms';
import { SlateEditable } from '../../../packages/src/components/editable/editable.component';
import { DemoButtonComponent } from '../components/button/button.component';

@Component({
    selector: 'demo-images',
    templateUrl: 'images.component.html',
    imports: [DemoButtonComponent, SlateEditable, FormsModule]
})
export class DemoImagesComponent implements OnInit {
    value = initialValue;

    editor = withImage(withAngular(createEditor()));

    constructor() {}

    renderElement() {
        return (element: Element) => {
            if (element.type === 'image') {
                return DemoElementImageComponent;
            }
            return null;
        };
    }

    ngOnInit() {}

    isImgUrl(imgUrl: string) {
        return new Promise((resolve, reject) => {
            const imgObj = new Image();
            imgObj.src = imgUrl;
            imgObj.onload = () => {
                resolve(true);
            };
            imgObj.onerror = () => {
                reject(false);
            };
        }).catch(error => {});
    }

    createImageNode(imgUrl: string) {
        const imageNode: ImageElement = {
            type: 'image',
            url: imgUrl,
            children: [
                {
                    text: ''
                }
            ]
        };
        Transforms.insertNodes(this.editor, imageNode);
    }

    addImages() {
        const imgUrl = window.prompt('Enter the URL of the image:');
        if (imgUrl) {
            this.isImgUrl(imgUrl).then(value => {
                if (value) {
                    this.createImageNode(imgUrl);
                } else {
                    window.alert('URL is not an image');
                }
            });
        }
    }

    valueChange(event) {}
}
const initialValue = [
    {
        type: 'paragraph',
        children: [
            {
                text: 'In addition to nodes that contain editable text, you can also create other types of nodes, like images or videos.'
            }
        ],
        key: 'HdSTK'
    },
    {
        type: 'image',
        url: 'https://github.com/images/modules/search/light2x.png',
        children: [
            {
                text: ''
            }
        ],
        key: 'EwcCn',
        voids: true
    },
    {
        type: 'paragraph',
        children: [
            {
                text: 'This example shows images in action. It features two ways to add images. You can either add an image via the toolbar icon above, or if you want in on a little secret, copy an image URL to your keyboard and paste it anywhere in the editor!'
            }
        ],
        key: 'ecJaY'
    },
    {
        type: 'paragraph',
        children: [
            {
                text: ''
            }
        ],
        key: 'zRTHT'
    }
];

const withImage = (editor: Editor) => {
    const { isVoid } = editor;

    editor.isVoid = element => {
        return element.type === 'image' || isVoid(element);
    };

    editor.isBlockCard = (element: Element) => {
        return element.type === 'image' || isVoid(element);
    };

    return editor;
};
